//TextMobilePortuguês.js
import { StatusBar } from 'expo-status-bar'
import React from 'react'
import { Text, View, Image, ScrollView, SafeAreaView } from 'react-native'
import * as Device from 'expo-device'
import LinkedInTag from 'react-linkedin-insight'

import styles from './Styles.js'

//import Head from './Head.js'
import Resumo from './Resumo.js'
import Apresentação from './Apresentação.js'
import Serviços from './Serviços.js'
import Contato from './Contato.js'
import Artigos from './Artigos.js'
import Copyright from './Copyright.js'

//const border = 1;

const TextMobilePortuguês = ({navigation}) => {
  //const disabled = !user.allowsThirdPartyCookies();
  //LinkedInTag.init(partnerId, 'dc', disabled);
  //LinkedInTag.track(conversionId);
  //if ((Device.brand) || (Device.brand == (null)))
   return (
    <SafeAreaView style={styles.containerMobile}>
      <StatusBar style="auto" />
      <ScrollView style={styles.principalMobile}>
        <View style={styles.head}>
          <View style={{borderWidth: border, width: 200}}>
            <Text
              style={styles.titleTextBlack}
            >
              Marcio Adriano Seno
            </Text>
          </View>
          <View style={{borderWidth: border}}>
            <Text
              style={styles.linkBlack}
              onPress={() => {navigation.navigate('TextMobile');}}
            >
              Eng
            </Text>
          </View>
        </View>
        {Resumo()}
        <Text> </Text>
        <Text> </Text>
        <View style={styles.logoViewMobile}>
          <Image style={styles.logoMobile} source={require('./img/LogoQuadradoCentralizado.png')} />
        </View>
        {Apresentação()}
        {Serviços()}
        {Contato()}
        <View style={styles.articlesMobile}>
          {Artigos()}
        </View>
        <View style={styles.copyrightMobile}>
          {Copyright()}
        </View>
      </ScrollView>
    </SafeAreaView>
  )
  // else {
    //navigation.navigate('TextDesktop');
  //  return null;
  //}
};
export default TextMobilePortuguês;
